import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./apiSlice";
import loginReducer from "reducers/loginReducer";
import extractedDumpsReducer from "reducers/extractedDumpsReducer";
import callsReducer from "reducers/callsReducer";
import rawPacketsReducer from "reducers/rawPacketsReducer";
import filesReducer from "reducers/filesReducer";

export const store = configureStore({
    reducer: {
        login: loginReducer,
        extractedDumps: extractedDumpsReducer,
        calls: callsReducer,
        rawPackets: rawPacketsReducer,
        files: filesReducer,
        [apiSlice.reducerPath]: apiSlice.reducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(apiSlice.middleware)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 